import {AddressType} from "../../../enums";
import {
    ColumnType,
    yascDisplayName,
    yascTableIgnore,
    yascMaxLength,
    yascMinLength,
    yascRequired,
    yascFormIgnore, yascClassFormSectionTitle,
} from '@yasc/yasc-material-components';
import {yascTableColumn} from '@yasc/yasc-material-components';

@yascClassFormSectionTitle('sidebarAccountAddresses')
export class AddressDetailRes {
    @yascTableIgnore(true)
    @yascFormIgnore()
    public id!: number;

    @yascTableIgnore(true)
    @yascFormIgnore()
    public type!: AddressType;

    @yascDisplayName('general_streetName')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public streetName!: string;

    @yascDisplayName('general_streetNumber')
    @yascRequired()
    @yascMaxLength(20)
    public streetNumber!: string;

    @yascDisplayName('general_city')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public city!: string;

    @yascDisplayName('general_zipCode')
    @yascRequired()
    @yascMinLength(3)
    @yascMaxLength(10)
    public zipCode!: string;

    @yascDisplayName('general_federalState')
    @yascRequired()
    @yascMaxLength(100)
    public federalState!: string;

    @yascDisplayName('general_country')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public country!: string;

    @yascDisplayName('generalDefault')
    @yascTableColumn(ColumnType.Switch)
    public default!: boolean;

    toString() {
        return this.streetName + ' ' + this.streetNumber + ', ' + this.zipCode + ' ' + this.city + ', ' + this.country;
    }
}

export class AddressReq {
    id: number = 0;
    city: string = "";
    country: string = "";
    streetName: string = "";
    streetNumber: string = "";
    zipCode: string = "";
    federalState?: string = "";
    default!: boolean;
    type!: AddressType;

    constructor(addressRes?: AddressDetailRes) {
        if (addressRes !== undefined) {
            this.id = addressRes.id;
            this.city = addressRes.city;
            this.country = addressRes.country;
            this.streetName = addressRes.streetName;
            this.streetNumber = addressRes.streetNumber;
            this.zipCode = addressRes.zipCode;
            this.federalState = addressRes.federalState;
            this.default = addressRes.default;
            this.type = addressRes.type;
        }
    }
}
